<template>
    <section class="page-footer">
        <AwardLogos
            :name="$store.state.awardsName"
            :classes="'award-logos--reset'"
        />

        <SocialIcons
            type="story"
            :staticPosition="true"
        />

        <Copyright />
    </section>
</template>

<script>
import AwardLogos from './Ui/AwardLogos'
import SocialIcons from './Ui/Socials'

export default {
    components: {
        AwardLogos,
        SocialIcons,
    },
}
</script>

<style lang="scss" scoped>
.page-footer {
    font-size: 1.5rem;
    padding: 2em 0;
    display: grid;
    gap: 2rem;

    > :nth-child(n) {
        padding-left: 20px;
        padding-right: 20px;
    }

    .story__socials {
        margin-top: 1em;
    }
}
@media (width > 1280px) {
    .page-footer {
        font-size: 3rem;
    }
}
</style>